export default __webpack_public_path__ + "static/media/logo-light.9db70cb9.svg";